import { render, staticRenderFns } from "./SectionSliderImageTextCard.vue?vue&type=template&id=0483ef64&scoped=true&"
import script from "./SectionSliderImageTextCard.vue?vue&type=script&lang=ts&"
export * from "./SectionSliderImageTextCard.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSliderImageTextCard.vue?vue&type=style&index=0&id=0483ef64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483ef64",
  null
  
)

export default component.exports